import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { Button } from '@material-ui/core';
import { isEmpty } from 'lodash';

import List, { ListProps } from 'embeds/components/List';

import ListNodesContext, { ListNodesContextProps } from './ListNodesContext';

const messages = defineMessages({
  clear: {
    id: 'deprecated.fragments.ListNodes.clear',
    defaultMessage: 'Clear selections',
  },
});

export interface ListNodesProps extends Omit<ListProps, 'classes'>, ListNodesContextProps {
  includeClearChecked?: boolean;
}

const ListNodes: React.FC<ListNodesProps> = ({
  idsSelected,
  idsChecked,
  includeClearChecked,
  onNodeSelected,
  onNodesChecked,
  ...rest
}) => {
  const context = useMemo(() => ({ idsSelected, idsChecked, onNodeSelected, onNodesChecked }), [
    idsSelected,
    idsChecked,
    onNodeSelected,
    onNodesChecked,
  ]);
  const { formatMessage } = useIntl();

  return (
    <ListNodesContext.Provider value={context}>
      {includeClearChecked && onNodesChecked && !isEmpty(idsChecked) && (
        <Button onClick={(event) => onNodesChecked(event, [])} fullWidth>
          {formatMessage(messages.clear)}
        </Button>
      )}
      <List {...rest} />
    </ListNodesContext.Provider>
  );
};

export default ListNodes;
